import { login, logout, getInfo } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'
import store from "../index";

const user = {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    roles: [],
    currentStore: null,
    storeList: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_BUTTON: (state, button) => {
      state.button = button
    },
    SET_CURRENT_STORE(state, store) {
      state.currentStore = store
    },
    SET_STORE_LIST(state, storeList) {
      state.storeList = storeList
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login(username, userInfo.password).then(response => {
          const data = response.data
          const tokenStr = data.tokenHead+data.token
          setToken(tokenStr)
          commit('SET_TOKEN', tokenStr)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          const data = response.data
          if (data.roles && data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', data.roles)
          } else {
            reject('getInfo: roles must be a non-null array !')
          }
          commit('SET_NAME', data.username)
          commit('SET_AVATAR', data.icon)
          let dataMenus = data.menus;
          let buttons = dataMenus.filter(item => item.level == 2);
          commit('SET_BUTTON', buttons)
          if (data.storeList && data.storeList.length > 0) { // 验证返回的storeList是否是一个非空数组
            commit('SET_STORE_LIST', data.storeList)
          } else {
            reject('getInfo: storeList must be a non-null array !')
          }
          // 判断本地是否已经存爱登录的门店信息
          const currentStore = data.currentStore;
          if (currentStore) {
            // 如果本地已经存储了门店信息，就使用上次登录的门店
            commit('SET_CURRENT_STORE', data.currentStore)
          } else {
            // 如果本地没有登录门店信息，就使用门店数组中的第一个门店
            commit('SET_CURRENT_STORE', data.storeList[0])
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_STORE_LIST', [])
          localStorage.setItem("currentStore", '');
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        localStorage.setItem("currentStore", '');
        removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js